import React from 'react'
import {
  Form,
  Input,
  Radio,
  DatePicker,
  Row,
  Col,
  Button,
} from 'antd';
import moment from 'moment';
import th from '../../../assets/img/biography.png';
class EAD extends React.Component {
  onChangeradio = (e) => {
    this.setState({ value: e.target.value });
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler({ ...values, birtH_DATE: moment(values.birtH_DATE).format("YYYYMMDD") });
      }
    });
  }
  componentDidMount = () => {
    const { setFieldsValue } = this.props.form;
    const { predata } = this.props;
    if (this.props.niprappoinment)
      setTimeout(() => { setFieldsValue({...this.props.niprappoinment,birtH_DATE:this.props.niprappoinment.birtH_DATE&&moment(this.props.niprappoinment.birtH_DATE)}) }, 100);
      else
      setTimeout(() => { setFieldsValue({
        firM_OR_LAST_NAME:predata&&predata.lname,
        firsT_NAME:predata&&predata.fname,
        middlE_NAME:predata&&predata.mname,
      }) }, 100);

  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div><Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
        <Row>
          <Col md={10} sm={24}>
            <img className='ant-login-image' alt="example" style={{ width: '450px', margin: '0', height: 450 }} src={th} />
          </Col>
          <Col md={14} sm={24}>
            <Row>
              <Col sm={24}>  <Form.Item>
                  {getFieldDecorator('namE_CODE', {
                    initialValue: '1'
                  })(<Input type='number' hidden maxLength={2} />)}
                </Form.Item></Col>
              <Col md={12} sm={24}>
              
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Last Name *</legend>
                    {getFieldDecorator('firM_OR_LAST_NAME', {
                      rules: [{ required: true, message: 'Please enter Last Name' }, {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                        message: "Last Name is not valid"
                      }, {
                        max: 100,
                        message: "Last Name is  must be at most 100 characters"
                      }],
                    })(<Input autoComplete={"nope"} maxLength={100} className="mi_input" type="text" placeholder="Enter Last Name" />)}
                  </fieldset>
                </Form.Item>
              </Col>
              <Col md={12} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">First Name *</legend>
                    {getFieldDecorator('firsT_NAME', {
                      rules: [{ required: true, message: 'Please enter First Name' }, {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                        message: "First Name is not valid"
                      }, {
                        max: 25,
                        message: "First Name is  must be at most 25 characters"
                      }],
                    })(<Input autoComplete={"nope"} maxLength={25} className="mi_input" type="text" placeholder="Enter First Name" />)}
                  </fieldset>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={12} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Middle Name</legend>
                    {getFieldDecorator('middlE_NAME', {
                      rules: [{
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                        message: "Middle Name is not valid"
                      }, {
                        max: 25,
                        message: "Middle Name is  must be at most 25 characters"
                      }],
                    })(<Input autoComplete={"nope"} maxLength={25} className="mi_input" type="text" placeholder="Enter Middle Name" />)}
                  </fieldset>
                </Form.Item>
              </Col>
              <Col md={12} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Suffix</legend>
                    {getFieldDecorator('suffiX_NAME', {
                      rules: [{
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                        message: "Suffix is not valid"
                      }, {
                        max: 10,
                        message: "Suffix is  must be at most 10 characters"
                      }],
                    })(<Input autoComplete={"nope"} maxLength={10} className="mi_input" type="text" placeholder="Enter Suffix" />)}
                  </fieldset>
                </Form.Item>
              </Col></Row>
            <Row>
              <Col md={12} sm={12}>
                <Form.Item>
                  {getFieldDecorator('gender', {
                    rules: [{ required: true, message: 'Please select gender' }]
                  })(
                    <Radio.Group className="mi_input_pop" style={{ marginLeft: "19px" }}>
                      <legend className="legend-font">Gender *</legend>
                      <Radio value="M">Male</Radio>
                      <Radio value="F">Female</Radio>
                    </Radio.Group>)}
                </Form.Item>
              </Col>
              <Col md={12} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Date of Birth *</legend>
                    {getFieldDecorator('birtH_DATE', {
                      rules: [{ required: true, message: 'Date of Birth is a required' }],
                    })(<DatePicker disabledDate={(current) => {
                      var date = new Date();
                      date.setFullYear(date.getFullYear() - 18);
                      return current && current > moment(date)
                    }} autoComplete={"nope"} allowClear={false} format="YYYYMMDD" className="mi_input" />)}
                  </fieldset>
                </Form.Item>
              </Col>
            </Row>
            {/* <Row>
              <Col md={12} sm={12}>
                <Radio.Group disabled className="mi_input_pop" style={{ marginLeft: "19px" }}>
                  <legend className="legend-font">Are you a citizen of the United States?</legend>
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no" onChange={this.onChangeradio}>No</Radio>

                </Radio.Group>
              </Col>

              {this.state.value === 'no' ?
                <Col md={12} sm={12}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Of which country are you a citizen?</legend>
                      {getFieldDecorator('country', {

                        rules: [{ required: true, message: 'Please enter Of which country are you a citizen?' },],
                      })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }

                        placeholder="Please Select Country ">
                        <Option value="albania">Albania</Option>
                        <Option value="afganisthan" >Afganisthan</Option>
                        <Option value="belgium" > Belgium</Option>
                        <Option value="india" > India</Option>
                        <Option value="iran" > Iran</Option>
                        <Option value="irak" > Irak</Option>
                      </Select>)} </fieldset>
                  </Form.Item></Col> : ''}
            </Row> */}
            <Row>
              <Col md={12} sm={24}>

                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">If applicable, FINRA Individual CRD</legend>
                    {getFieldDecorator('nasD_CRD', {
                      rules: [{ required: true, message: 'FINRA Individual CRD is a required' },
                        {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[0-9\s]+$/,
                        message: "Only Financial Industry Regulatory Authority (FINRA) numbers are allowed"
                      },
                      {
                        max: 7,
                        message: "Value should be less than 7 character",
                      },],
                    })(<Input autoComplete={"nope"} type="number" className="mi_input" placeholder="Enter FINRA number" />)}
                  </fieldset>
                </Form.Item>
              </Col>
            </Row>
            <Row>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <div className="collapsepanel-footer "> <Button className=" ant-btn-primary" htmlType="submit"
              style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}>
              Next</Button> </div>
          </Col>  </Row>
      </Form>
      </div>
    )
  }
}

const NiprBiographicData = Form.create()(EAD);

export default NiprBiographicData;